import React from "react";

const ItalicIcon = props => (
  <svg width={9} height={10} viewBox="0 0 9 10" {...props}>
    <defs>
      <linearGradient id="a" x1="-15.842%" x2="109.964%" y1="13.157%" y2="116.349%">
        <stop offset="0%" stopColor="#00B1FF" />
        <stop offset="72.016%" stopColor="#0060E7" />
        <stop offset="100%" stopColor="#0046DF" />
        <stop offset="100%" stopColor="#D3E1EF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-434 -707)">
      <path fill="url(#a)" d="M0 85h1439v635H0z" />
      <rect width={730} height={1584} x={65} y={458} fill="currentColor" rx={5} />
      <g transform="translate(387 695)">
        <rect width={258} height={32} fill="#212121" rx={4} />
        <path
          fill="currentColor"
          d="M50 12v2.143h1.65l-2.625 5.714H47V22h6v-2.143h-1.725l2.625-5.714H56V12z"
        />
      </g>
    </g>
  </svg>
);

export default ItalicIcon;
